module.exports = __webpack_public_path__ + "assets/images/espn_america.85ed2a78344529a2fd5c3e3b530f8a2f.png";